import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { reduxForm } from "redux-form";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import { setActivateAccount, setAfterActivation } from "../actions/appActions";
import { createAccount } from "../actions/userActions";

const ActivateAccount = ({
  history,
  activateAccount,
  handleSubmit,
  fail,
  setAfterActivation
}) => {
  if (activateAccount) {
    return (
      <form
        onSubmit={handleSubmit}
        className="form activate-account flex-row flex-centered"
      >
        <Card>
          <CardText>
            <div className="flex-row flex-centered margin-bottom-small">
              Chcete aktivovat účet?
            </div>
            {fail && (
              <div className="flex-row flex-centered margin-bottom-small error">
                {fail}
              </div>
            )}
            <div className="flex-row flex-centered">
              <Button
                flat
                label="Odmítnout"
                className="btn"
                onClick={() => {
                  setAfterActivation();
                  history.push("/");
                }}
              />
              <Button
                flat
                primary
                label="Příjmout"
                type="submit"
                className="btn btn-primary"
              />
            </div>
          </CardText>
        </Card>
      </form>
    );
  }

  return <div />;
};

export default compose(
  connect(({ app: { activateAccount } }) => ({ activateAccount }), {
    setActivateAccount,
    createAccount,
    setAfterActivation
  }),
  withState("fail", "setFail", null),
  lifecycle({
    componentWillUnmount() {
      const { setActivateAccount } = this.props;

      setActivateAccount(null);
    }
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const {
        history,
        createAccount,
        activateAccount,
        setFail,
        setAfterActivation
      } = props;
      const response = await createAccount(activateAccount);

      if (response === 200 || response === 201 || response === 204) {
        setAfterActivation();
        history.push("/");
      } else if (response === 404) {
        setFail("Účet byl již aktivován.");
      } else {
        setFail("Účet se nepodařilo aktivovat.");
      }
    }
  }),
  reduxForm({ form: "activateAccountForm" })
)(ActivateAccount);



// WEBPACK FOOTER //
// ./src/pages/ActivateAccount.js